export const APPROVAL_NOTIFICATION = 'APPROVAL_NOTIFICATION';
export const PUSH_NOTIFICATION = 'PUSH_NOTIFICATION';

export const pushTitleTranslatePath = {
    notdone: 'notify.pushTitle.notdone',
    person: 'notify.pushTitle.person',
    project: 'notify.pushTitle.project',
};

export const pushDescriptionTranslatePath = {
    notdone: 'notify.notDone',
    person: 'notify.approvalPerson',
    project: 'notify.approvalProject',
};
